export const GET_OVERVIEW = 'GET_OVERVIEW'
export const GET_OVERVIEW_SUCCESS = 'GET_OVERVIEW_SUCCESS'
export const GET_LAST_INVOICES = 'GET_LAST_INVOICES';
export const GET_LAST_INVOICES_SUCCESS = 'GET_LAST_INVOICES_SUCCESS';
